import React from "react";
import "components/Feeds/Feeds.css";
import DefaultProfilePic from "site_media/images/default-profile-pic-feeds.png";
/**
 * @description Displays the project started by his friends.
 * @class FriendStartedProject
 * @implements none
 * @extends React.Component
 * @type {FriendStartedProjectStartedProject}
 * @example <FriendStartedProject />
 * pre-condition: all the imports
 * post-condition: returns a form with the project started by the user.
 * @param profilePic, userName, time, projectbadge, projectName
 * @returns {FriendStartedProject}
 */

class FriendStartedProject extends React.Component {
	render() {
		let event = new Date(this.props.time);
		const formattedDate = Intl.DateTimeFormat("en-US", {
			year: "numeric",
			month: "short",
			day: "2-digit",
		}).format(event);
		const time = event.toLocaleTimeString("en-US");

		return (
			<div className="feed-wrapper">
				<div className="feed-form">
					<p className="mobile-profile-pic">
						<img
							alt="profile-pic"
							className="profile-pic"
							src={this.props.profilePic || DefaultProfilePic}
						/>
					</p>
					<p className="mobile-intro">
						<label style={{ fontWeight: "bold" }}>{this.props.userName}</label>
						<label>
							Project was started on {formattedDate}, {time}
						</label>
					</p>
				</div>
				<div className="feed-display-adjacent">
					<p>
						<img
							className="display-pic-adjacent"
							alt="profile-pic"
							src={this.props.profilePic || DefaultProfilePic}
						/>
					</p>
					<p>
						<img
							className="display-pic-adjacent"
							alt="project-badge"
							src={this.props.projectBadge}
						/>
					</p>
				</div>
				<div className="feed-form">
					<label>
						Congratulations! Your friend {" "} {this.props.userName} has just started the impact project,{" "}
						<i>{this.props.projectName}</i>.
						impact goals today!
					</label>
				</div>
			</div>
		);
	}
}

export default FriendStartedProject;
